export default __webpack_public_path__ + "static/media/proj1_4.88dcb2c5.jpg";